// Phase 44.31.2 — Display cleaning per indirizzi geocoded (CH + IT).
//
// Problemi reali riportati su iPhone (pilot):
//   "Via Antonio Rinaldi 3, 6850 Mendrisio, Mendrisio"
//      → "Mendrisio" finale è il DISTRETTO (uguale al comune) — confonde
//   "Corso San Gottardo 8, 6830 Chiasso, Mendrisio"
//      → "Mendrisio" finale è il distretto, NON la città — confonde ancora di più
//   "Via San Fermo 19, 22020 Parè, LOMB, Italia"
//      → "LOMB" è regione, "Italia" è nazione — entrambi inutili al driver
//   "Via Mulini 1115, 22020 Corte Re, CO, Italia"
//      → "CO" è provincia, "Italia" nazione
//
// Regola: passiamo l'indirizzo per round di pulizia finali, finché non
// arriviamo a un segmento "vero" (con cifre = CAP + città).
// Rimuoviamo i segmenti finali che sono:
//   • nazioni note (Italia, Svizzera, France, ...)
//   • province IT a 2 lettere maiuscole (CO, MI, RM, …) — anche cantoni CH (TI, ZH)
//     ATTENZIONE: nel pilot DapNow opera in CH/IT, i 2-lettere finali sono ridondanti
//     (il CAP+città danno già localizzazione sufficiente). L'utente li percepisce come rumore.
//   • abbreviazioni regione IT a 3-5 lettere maiuscole (LOMB, PIEM, VENE, ...)
//   • toponimi senza cifre che ricorrono in altri segmenti (es. "Mendrisio" doppio)
//
// Output canonico: "Via X N, NNNN Città"

const COUNTRY_REGEX = /^(italia|italy|italie|svizzera|switzerland|suisse|schweiz|francia|france|germania|germany|deutschland|austria|österreich)$/i;
const PROVINCE_OR_CANTON_REGEX = /^[A-Z]{2}$/;          // CO, MI, TI, ZH, BS, …
const REGION_ABBR_REGEX = /^[A-Z]{3,5}$/;               // LOMB, PIEM, VENE, FVG, …

function _isStripStable(segment, otherSegments) {
  if (!segment) return true;
  const s = segment.trim();
  if (!s) return true;
  if (COUNTRY_REGEX.test(s)) return true;
  if (PROVINCE_OR_CANTON_REGEX.test(s)) return true;
  if (REGION_ABBR_REGEX.test(s) && s === s.toUpperCase()) return true;
  // Se ha cifre (CAP, civico) NON rimuovere
  if (/\d/.test(s)) return false;
  // Toponimo doppio: già presente in un segmento precedente
  // Es: "Chiasso, Mendrisio" — Mendrisio è il distretto, non duplicato MA
  //     "Mendrisio, Mendrisio" — Mendrisio già presente → rimuovi
  const sNorm = s.toLowerCase();
  for (const other of otherSegments) {
    if (!other) continue;
    if (other.toLowerCase().includes(sNorm)) return true;
  }
  // Phase 44.31.2 — Lista distretti TI noti: se compaiono in coda dopo un
  // segmento con CAP+città DIVERSA, sono comunque ridondanti per l'utente.
  // I distretti del Ticino sono solo 8, li hard-codiamo: l'utente conosce le città.
  const TI_DISTRICTS = new Set([
    "mendrisio", "lugano", "bellinzona", "locarno",
    "blenio", "leventina", "riviera", "valle maggia", "vallemaggia",
  ]);
  if (TI_DISTRICTS.has(sNorm)) return true;
  return false;
}

export function formatAddress(addr) {
  if (!addr || typeof addr !== "string") return addr || "";
  let parts = addr.split(",").map((s) => s.trim()).filter(Boolean);
  if (parts.length < 2) return addr;

  // Round di pulizia dalla coda finché trovi un segmento "vero"
  let safety = 6;
  while (parts.length >= 2 && safety-- > 0) {
    const last = parts[parts.length - 1];
    const rest = parts.slice(0, -1);
    if (_isStripStable(last, rest)) {
      parts = rest;
    } else {
      break;
    }
  }
  return parts.join(", ");
}
